import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { Icon } from "../../components/Component";
import { deleteUser } from "../../api/user";
import { toast } from "react-toastify";

const DeleteModal = ({ DeleteDetails, handelModal, modal, mutation }) => {
  const [loading, setLoading] = useState(false);
  const toggle = () => handelModal(!modal);
  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await deleteUser(id);
      toast.success(response?.data?.message, {
        position: "top-center",
      });
      toggle();
      mutation();
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <li className="preview-item">
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader
            toggle={toggle}
            close={
              <button className="close" onClick={toggle}>
                <Icon name="cross" />
              </button>
            }
          >
            Delete User
          </ModalHeader>
          <ModalBody>
            <p className=" fw-bold fs-16px">
              Are you sure you want to delete this user?
            </p>
            <div className=" w-100 d-flex justify-content-end">
              <Button color="white" onClick={toggle}>
                Cancel
              </Button>
              <Button
                color="danger"
                onClick={() => {
                  handleDelete(DeleteDetails?.id);
                }}
              >
                {loading ? <Spinner color="white" size="sm" /> : "Confirm"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </li>
    </div>
  );
};

export default DeleteModal;
